import styled from 'styled-components';

export const ExampleQuestionsContainer = styled.div`
  margin-top: 15px;
`;

export const FilterListContainer = styled.div`
  display: flex;
  flex-direction: column;
  opacity: 0;
  max-height: 0;
  overflow: hidden;
  transform: translateY(20px);
  pointer-events: none;
  transition:
    opacity 300ms ease,
    transform 300ms ease,
    max-height 300ms ease;

  &.visible {
    opacity: 1;
    max-height: 60vh;
    transform: translateY(0);
    pointer-events: auto;
  }
`;

export const FilterListEnd = styled.div`
  opacity: 0;
`;

export const ExampleQuestions = styled.div`
  display: flex;
  align-items: center;
`;
